module.exports = __webpack_public_path__ + "img/cityGeneratorCover.155b3086.png";